import React from 'react';
import { MapPin, Mail, Phone, Clock, Facebook, Instagram } from 'lucide-react';
import { Link } from 'react-router-dom';
import { businessInfo } from '../data/mock';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_tilefix-scheduler/artifacts/c05hbcds_IMG_1809.png";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: 'Services', href: '#services' },
    { name: 'About Us', href: '#about' },
    { name: 'Testimonials', href: '#testimonials' },
    { name: 'Contact', href: '#contact' }
  ];

  const services = [
    'Bathroom Tile',
    'Kitchen Backsplash',
    'Floor Tiling',
    'Custom Designs'
  ];

  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#0d1f33] border-t border-[#F7931E]/20">
      <div className="container py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Company Info */}
          <div>
            <div className="mb-6">
              <img 
                src={LOGO_URL} 
                alt="Top Notch Tile LLC" 
                className="h-20 w-auto"
              />
            </div>
            <p className="text-[#8fa3b8] leading-relaxed mb-6">
              Cape Cod's trusted tile experts. Bringing precision craftsmanship 
              to every bathroom, kitchen, and floor project since 2009.
            </p>
            <div className="flex items-center gap-2 text-[#F7931E] mb-4">
              <Clock size={16} />
              <span className="text-sm">Mon-Sat: 7AM - 6PM</span>
            </div>
            {/* Social Media Links */}
            <div className="flex items-center gap-4">
              <a 
                href="https://www.facebook.com/profile.php?id=100091266620716" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-[#1B3A5F] rounded-lg flex items-center justify-center text-[#8fa3b8] hover:text-[#F7931E] hover:bg-[#254a73] transition-all"
                aria-label="Facebook"
              >
                <Facebook size={20} />
              </a>
              <a 
                href="https://www.instagram.com/Top_Notch_Tile_" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-[#1B3A5F] rounded-lg flex items-center justify-center text-[#8fa3b8] hover:text-[#F7931E] hover:bg-[#254a73] transition-all"
                aria-label="Instagram"
              >
                <Instagram size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-bold text-lg mb-6">Quick Links</h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    onClick={(e) => scrollToSection(e, link.href)}
                    className="text-[#8fa3b8] hover:text-[#F7931E] transition-colors"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-bold text-lg mb-6">Our Services</h4>
            <ul className="space-y-3">
              {services.map((service) => (
                <li key={service}>
                  <span className="text-[#8fa3b8]">{service}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-bold text-lg mb-6">Contact Us</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin size={20} className="text-[#F7931E] mt-1 flex-shrink-0" />
                <span className="text-[#8fa3b8]">{businessInfo.address}</span>
              </li>
              <li className="flex items-center gap-3">
                <Mail size={20} className="text-[#F7931E] flex-shrink-0" />
                <a 
                  href={`mailto:${businessInfo.email}`}
                  className="text-[#8fa3b8] hover:text-[#F7931E] transition-colors"
                >
                  {businessInfo.email}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={20} className="text-[#F7931E] flex-shrink-0" />
                <a 
                  href={`tel:${businessInfo.phone.replace(/\D/g, '')}`}
                  className="text-[#8fa3b8] hover:text-[#F7931E] transition-colors"
                >
                  {businessInfo.phone}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-[#F7931E]/20">
        <div className="container py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-[#8fa3b8] text-sm">
              © {currentYear} {businessInfo.name}. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <p className="text-[#8fa3b8] text-sm">
                Proudly serving {businessInfo.serviceArea}
              </p>
              <Link to="/admin" className="text-[#8fa3b8] text-sm hover:text-[#F7931E] transition-colors">
                Admin Login
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
